import { observer } from "mobx-react-lite";
import { MDSButton, MDSButtonVariant } from "@/mds";

export interface RecordingControlsProps {
  status: "IDLE" | "RECORDING" | "PAUSED" | "STOPPED";
  onStart(): void;
  onPause(): void;
  onResume(): void;
  onStop(): void;
  isDisabled?: boolean;
  hasExistingData?: boolean;
}

export const RecordingControls = observer(
  ({
    status,
    onStart,
    onPause,
    onResume,
    onStop,
    isDisabled = false,
    hasExistingData = false,
  }: RecordingControlsProps) => {
    return (
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
        <MDSButton onClick={onStart} isDisabled={isDisabled || status !== "IDLE"}>
          {hasExistingData ? "Resume" : "Start"}
        </MDSButton>
        <MDSButton
          onClick={onPause}
          isDisabled={isDisabled || status !== "RECORDING"}
          variant={MDSButtonVariant.Subtle}
        >
          Pause
        </MDSButton>
        <MDSButton
          onClick={onResume}
          isDisabled={isDisabled || status !== "PAUSED"}
          variant={MDSButtonVariant.Subtle}
        >
          Resume
        </MDSButton>
        <MDSButton
          onClick={onStop}
          isDisabled={isDisabled || (status !== "RECORDING" && status !== "PAUSED")}
          variant={MDSButtonVariant.Danger}
        >
          Stop
        </MDSButton>
      </div>
    );
  }
);

export default RecordingControls;
